import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import "./Sidebar.css";

import Dropdown from "react-bootstrap/Dropdown";
import NavDropdown from "react-bootstrap/NavDropdown";

import NavItem from "./NavItem";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHome,
    faCloudUploadAlt
} from "@fortawesome/free-solid-svg-icons";

const Sidebar = ({ props }) => {
    const sidebarClass = props.showMenu ? "sidebar navbar-nav toggled" : "sidebar navbar-nav";

    const [activeNav, setActiveNav] = useState("/");
    const [userRole, setUserRole] = useState(null); // Store user role

    useEffect(() => {
        const fetchUserRole = async () => {
            const token = localStorage.getItem("token");
            if (!token) return; // Ensure there's a token before making API calls

            try {
                const response = await axiosInstance.get("/users/currentUser", {
                    headers: {
                        "Authorization": token,
                    },
                });

                if (response.data.success && response.data.data.user) {
                    setUserRole(response.data.data.user.role); // Set the user role
                }
            } catch (error) {
                console.error("Error fetching user role:", error);
            }
        };

        fetchUserRole();
    }, []);

    return (
        <>
            <ul className={sidebarClass}>
                <NavItem
                    href="/"
                    faIcon={faHome}
                    label="Home"
                    active={activeNav === '/'}
                    onClick={() => setActiveNav('/')}
                />
                 {userRole === "Admin" && (
                <NavItem
                    href="/track"
                    faIcon={faCloudUploadAlt}
                    label="Tracks"
                    active={activeNav === '/track'}
                    onClick={() => setActiveNav('/track')}
                />
                 )}
                 {userRole === "Admin" && (
                <NavItem
                    href="/match-car"
                    faIcon={faCloudUploadAlt}
                    label="Match Car"
                    active={activeNav === '/match-car'}
                    onClick={() => setActiveNav('/match-car')}
                />
                 )}

                {/* Show "Members List" only if user is an Admin */}

                 {/* {userRole === "Admin" && (
                <NavItem
                        href="/add-users"
                        faIcon={faCloudUploadAlt}
                        label="Add Users"
                        active={activeNav === '/add-users'}
                        onClick={() => setActiveNav('/add-users')}
                />
                )} */}

                {userRole === "Admin" && (

                    <NavItem
                        href="/members-list"
                        faIcon={faCloudUploadAlt}
                        label="Members List"
                        active={activeNav === '/members-list'}
                        onClick={() => setActiveNav('/members-list')}
                    />
                )}

                <NavItem
                    href="/download-app"
                    faIcon={faCloudUploadAlt}
                    label="Download App"
                    active={activeNav === '/download-app'}
                    onClick={() => setActiveNav('/download-app')}
                />
                    <NavItem
                        href="/track-data"
                        faIcon={faCloudUploadAlt}
                        label="Track Data"
                        active={activeNav === '/track-data'}
                        onClick={() => setActiveNav('/track-data')}
                    />

                    {userRole === "User" && (

                    <NavItem
                        href="/contact-us"
                        faIcon={faCloudUploadAlt}
                        label="Contact Us"
                        active={activeNav === '/contact-us'}
                        onClick={() => setActiveNav('/contact-us')}
                    />
                )}

                    <NavItem
                        href="/races-events"
                        faIcon={faCloudUploadAlt}
                        label="Races Events"
                        active={activeNav === '/races-events'}
                        onClick={() => setActiveNav('/races-events')}
                    />
                    
            </ul>
        </>
    );
};

export default Sidebar;
